import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0655492a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "conditioner"
};
const _hoisted_2 = {
  class: "title-me"
};
const _hoisted_3 = {
  class: "tab-box"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass({
    'card': true
  })
};
const _hoisted_9 = ["id"];
const _hoisted_10 = ["src"];
const _hoisted_11 = ["id"];
const _hoisted_12 = ["src"];
const _hoisted_13 = ["id"];
const _hoisted_14 = ["src"];
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "reveal-box"
};
const _hoisted_17 = {
  key: 0,
  class: "reveal"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  key: 1,
  class: "reveal"
};
const _hoisted_21 = ["src"];
const _hoisted_22 = ["src"];
const _hoisted_23 = {
  key: 2,
  class: "reveal"
};
const _hoisted_24 = ["src"];
const _hoisted_25 = ["src"];
const _hoisted_26 = {
  key: 3,
  class: "reveal"
};
const _hoisted_27 = ["src"];
const _hoisted_28 = ["src"];
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { formatSize } from '@/utils';
import i18n from '@/language/index';
export default {
  __name: 'FunctionIntroduction',
  setup(__props) {
    const router = useRouter();
    const imgUrl = ref({
      icon1: require('@/assets/images/view-detail-small.png'),
      icon2: require('@/assets/images/model-logo2-small.png'),
      icon3: require('@/assets/images/model-logo1-small.png'),
      icon4: require('@/assets/images/view-detail-large.png'),
      icon5: require('@/assets/images/model-logo2-large.png'),
      icon6: require('@/assets/images/model-logo1-large.png'),
      icon7: require('@/assets/images/model-logo2-large.png'),
      icon8: require('@/assets/images/AI-small.png'),
      icon9: require('@/assets/images/AI-large.png'),
      icon10: require('@/assets/images/inspection-small.png'),
      icon11: require('@/assets/images/inspection-large.png')
    });
    const gotoUrl = ref({
      goto: require('@/assets/images/goto.png'),
      reveal1: require('@/assets/images/model-img3.png'),
      reveal2: require('@/assets/images/model-img1.png'),
      reveal3: require('@/assets/images/mainPage.png'),
      reveal4: require('@/assets/images/cultural-relic-desc.png'),
      reveal5: require('@/assets/images/AI-desc.png'),
      reveal6: require('@/assets/images/inspiration.png')
    });
    const num = ref(1);
    const itemListDom = ref('');
    const tabChange = value => {
      num.value = value;
    };
    const enter = (el, done) => {
      // const icon = itemListDom.value.querySelectorAll('div')[num.value - 1].querySelector('img')
      const icon2 = el.querySelector('img');
      // icon2.style.display = 'none'

      let t = 0;
      const b = 0;
      const c = 1;
      const d = 20;
      const elChildren = [el.querySelector('h5'), el.querySelector('p'), el.querySelector('a'), el.querySelector('img')];
      const step = function () {
        const value = linear(t, b, c, d);
        elChildren.forEach(item => {
          item.style.opacity = value;
        });
        t++;
        if (t <= d) {
          requestAnimationFrame(step);
        } else {
          icon2.style.display = 'block';
          done();
        }
      };
      step();
    };
    const leave = (el, done) => {
      let t = 0;
      const b = parseInt(window.getComputedStyle(el).left);
      const c = (num.value - 1) * formatSize(380) - b;
      const d = 20;
      const b2 = 1;
      const c2 = -1;
      const elChildren = [el.querySelector('h5'), el.querySelector('p'), el.querySelector('a'), el.querySelector('img')];
      const step = function () {
        const value = linear(t, b, c, d);
        const value2 = linear(t, b2, c2, d);
        el.style.left = value + 'px';
        elChildren.forEach(item => {
          item.style.opacity = value2;
        });
        t++;
        if (t <= d) {
          requestAnimationFrame(step);
        } else {
          done();
        }
      };
      step();
    };
    const linear = (t, b, c, d) => {
      return c * t / d + b;
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('home.WeCan')), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        ref_key: "itemListDom",
        ref: itemListDom,
        class: "item-list"
      }, [_createElementVNode("div", null, [_createElementVNode("img", {
        src: imgUrl.value.icon1,
        onClick: _cache[0] || (_cache[0] = $event => tabChange(1)),
        alt: "{{$t('home.CopyrightProtection')}}"
      }, null, 8, _hoisted_4), _createElementVNode("p", {
        onClick: _cache[1] || (_cache[1] = $event => tabChange(1))
      }, _toDisplayString(_ctx.$t('home.CopyrightProtection')), 1)]), _createElementVNode("div", null, [_createElementVNode("img", {
        id: "culturalRelic",
        src: imgUrl.value.icon7,
        onClick: _cache[2] || (_cache[2] = $event => tabChange(2)),
        alt: "{{$t('home.culturalRelicDesc')}}"
      }, null, 8, _hoisted_5), _createElementVNode("p", {
        onClick: _cache[3] || (_cache[3] = $event => tabChange(2))
      }, _toDisplayString(_ctx.$t('home.culturalRelicDesc')), 1)]), _createElementVNode("div", null, [_createElementVNode("img", {
        src: imgUrl.value.icon9,
        onClick: _cache[4] || (_cache[4] = $event => tabChange(3)),
        alt: "{{$t('home.helloAi')}}"
      }, null, 8, _hoisted_6), _createElementVNode("p", {
        onClick: _cache[5] || (_cache[5] = $event => tabChange(3))
      }, _toDisplayString(_ctx.$t('home.helloAi')), 1)]), _createElementVNode("div", null, [_createElementVNode("img", {
        src: imgUrl.value.icon11,
        onClick: _cache[6] || (_cache[6] = $event => tabChange(4)),
        alt: "{{$t('home.inspection')}}"
      }, null, 8, _hoisted_7), _createElementVNode("p", {
        onClick: _cache[7] || (_cache[7] = $event => tabChange(4))
      }, _toDisplayString(_ctx.$t('home.inspection')), 1)])], 512), _createVNode(_Transition, {
        mode: "out-in",
        onEnter: enter,
        onLeave: leave,
        css: false
      }, {
        default: _withCtx(() => [num.value === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("h5", null, _toDisplayString(_ctx.$t('home.CopyrightProtection')), 1), _createElementVNode("p", {
          id: _unref(i18n).global.locale.value === 'en' ? 'text' : ''
        }, _toDisplayString(_ctx.$t('home.text')), 9, _hoisted_9), _createVNode(_component_router_link, {
          to: "/CopyrightProtection"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.LoadMore')), 1)]),
          _: 1
        }), _createElementVNode("img", {
          src: imgUrl.value.icon4,
          alt: "{{$t('home.CopyrightProtection')}}",
          class: "icon"
        }, null, 8, _hoisted_10)])) : num.value === 2 ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass({
            'card': true,
            'left300': num.value === 2
          })
        }, [_createElementVNode("h5", null, _toDisplayString(_ctx.$t('home.culturalRelicDesc')), 1), _createElementVNode("p", {
          id: _unref(i18n).global.locale.value === 'en' ? 'text' : ''
        }, _toDisplayString(_ctx.$t('home.culturalRelicDetail')), 9, _hoisted_11), _createVNode(_component_router_link, {
          to: "/Artalk"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.LoadMore')), 1)]),
          _: 1
        }), _createElementVNode("img", {
          src: imgUrl.value.icon2,
          alt: "{{$t('home.culturalRelicDesc')}}",
          class: "icon"
        }, null, 8, _hoisted_12)], 2)) : num.value === 3 ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass({
            'card': true,
            'left600': num.value === 3
          })
        }, [_createElementVNode("h5", null, _toDisplayString(_ctx.$t('home.helloAi')), 1), _createElementVNode("p", {
          id: _unref(i18n).global.locale.value === 'en' ? 'text' : ''
        }, _toDisplayString(_ctx.$t('home.helloAiDetail')), 9, _hoisted_13), _createVNode(_component_router_link, {
          to: "/ComingSoon"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.LoadMore')), 1)]),
          _: 1
        }), _createElementVNode("img", {
          src: imgUrl.value.icon8,
          alt: "{{$t('home.helloAi')}}",
          class: "icon"
        }, null, 8, _hoisted_14)], 2)) : num.value === 4 ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass({
            'card': true,
            'left900': num.value === 4
          })
        }, [_createElementVNode("h5", null, _toDisplayString(_ctx.$t('home.inspection')), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t('home.inspectionDetail')), 1), _createVNode(_component_router_link, {
          to: "/ComingSoon"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('home.LoadMore')), 1)]),
          _: 1
        }), _createElementVNode("img", {
          src: imgUrl.value.icon10,
          alt: "{{$t('home.ComingSoon')}}",
          class: "icon"
        }, null, 8, _hoisted_15)], 2)) : _createCommentVNode("", true)]),
        _: 1
      })]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", null, [num.value === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_Transition, {
        appear: "",
        mode: "out-in",
        name: "animate__animated animate__bounce",
        "enter-active-class": "animate__animated animate__InLeft",
        "leave-active-class": "animate__animated animate__fadeOut"
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          class: "revealImg",
          src: gotoUrl.value.reveal1,
          alt: ""
        }, null, 8, _hoisted_18)]),
        _: 1
      }), _createElementVNode("div", {
        class: _normalizeClass(["reveal-right", [num.value === 1 ? 'rightTextShow' : 'rightTextNone']])
      }, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('home.creativity')), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('home.protection')), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('home.concept')), 1), _createElementVNode("div", {
        onClick: _cache[8] || (_cache[8] = $event => _unref(router).push('/CopyrightProtection'))
      }, [_createTextVNode(_toDisplayString(_ctx.$t('home.tryNow')) + " ", 1), _createElementVNode("img", {
        src: gotoUrl.value.goto,
        alt: "{{$t('home.creativity')}}",
        style: {
          "vertical-align": "middle"
        }
      }, null, 8, _hoisted_19)])], 2)])) : _createCommentVNode("", true), num.value === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_Transition, {
        appear: "",
        mode: "out-in",
        name: "animate__animated animate__bounce",
        "enter-active-class": "animate__animated animate__InLeft",
        "leave-active-class": "animate__animated animate__fadeOut"
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          class: "revealImg",
          src: gotoUrl.value.reveal4,
          alt: ""
        }, null, 8, _hoisted_21)]),
        _: 1
      }), _createElementVNode("div", {
        class: _normalizeClass(["reveal-right", [num.value === 2 ? 'rightTextShow' : 'rightTextNone']])
      }, [_createElementVNode("div", {
        class: _normalizeClass(_unref(i18n).global.locale.value === 'en' ? 'reveal-right-Antiquity' : '')
      }, _toDisplayString(_ctx.$t('home.culturalImgDescRight1')), 3), _createElementVNode("div", null, _toDisplayString(_ctx.$t('home.culturalImgDescRight2')), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('home.culturalImgDescRight3')), 1), _createElementVNode("div", {
        onClick: _cache[9] || (_cache[9] = $event => _unref(router).push('/Artalk'))
      }, [_createTextVNode(_toDisplayString(_ctx.$t('home.tryNow')) + " ", 1), _createElementVNode("img", {
        src: gotoUrl.value.goto,
        alt: "{{$t('home.ComingSoon')}}",
        style: {
          "vertical-align": "middle"
        }
      }, null, 8, _hoisted_22)])], 2)])) : _createCommentVNode("", true), num.value === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_Transition, {
        appear: "",
        mode: "out-in",
        name: "animate__animated animate__bounce",
        "enter-active-class": "animate__animated animate__InLeft",
        "leave-active-class": "animate__animated animate__fadeOut"
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          class: "revealImg",
          src: gotoUrl.value.reveal5,
          alt: ""
        }, null, 8, _hoisted_24)]),
        _: 1
      }), _createElementVNode("div", {
        class: _normalizeClass(["reveal-right", [num.value === 3 ? 'rightTextShow' : 'rightTextNone']])
      }, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('home.helloAiRight1')), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('home.helloAiRight2')), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('home.helloAiRight3')), 1), _createElementVNode("div", {
        onClick: _cache[10] || (_cache[10] = $event => _unref(router).push('/AIHeuristicCard/home'))
      }, [_createTextVNode(_toDisplayString(_ctx.$t('home.tryNow')) + " ", 1), _createElementVNode("img", {
        src: gotoUrl.value.goto,
        alt: "{{$t('home.creativity')}}",
        style: {
          "vertical-align": "middle"
        }
      }, null, 8, _hoisted_25)])], 2)])) : _createCommentVNode("", true), num.value === 4 ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createVNode(_Transition, {
        appear: "",
        mode: "out-in",
        name: "animate__animated animate__bounce",
        "enter-active-class": "animate__animated animate__InLeft",
        "leave-active-class": "animate__animated animate__fadeOut"
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          class: "revealImg",
          src: gotoUrl.value.reveal6,
          alt: ""
        }, null, 8, _hoisted_27)]),
        _: 1
      }), _createElementVNode("div", {
        class: _normalizeClass(["reveal-right", [num.value === 4 ? 'rightTextShow' : 'rightTextNone']])
      }, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('home.inspectionRight1')), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('home.inspectionRight2')), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('home.inspectionRight3')), 1), _createElementVNode("div", {
        onClick: _cache[11] || (_cache[11] = $event => _unref(router).push('/ComingSoonThree'))
      }, [_createTextVNode(_toDisplayString(_ctx.$t('home.tryNow')) + " ", 1), _createElementVNode("img", {
        src: gotoUrl.value.goto,
        alt: "{{$t('home.ComingSoon')}}",
        style: {
          "vertical-align": "middle"
        }
      }, null, 8, _hoisted_28)])], 2)])) : _createCommentVNode("", true)])])]);
    };
  }
};